import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import WorkOrdersTable from "@/components/operations/work-orders/work-orders-table";

const tableSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/operations/work-orders/_list/table",
)({
  validateSearch: tableSearchSchema,
  component: WorkOrdersTablePage,
});

function WorkOrdersTablePage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "work_orders", actions: ["read"] }]}>
      
    <div className="flex-1 flex flex-col min-h-0 pb-4">
      <WorkOrdersTable
        currentPage={searchParams.page}
        basePath="/operations/work-orders/table"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
